export const getLocationWithQueryParams = (route) => {
    return `${route}${window.location.search}`;
};
export const isOpp = () => window.location.search.includes("opp=true");
//# sourceMappingURL=getLocationWithQueryParams.js.map